<template>
  <div
    class="faq-block"
    :class="{'faq-block_overlap': overlap_previous}">
    <!-- Decorul sta in afara containerului, ca sa se intinda pe toata latimea paginii
         asa cum e in macheta. `z-index: -1` din CSS il trimite sub cardul gri si sub
         footer, fara sa fie nevoie de vreo interventie in footer. -->
    <div
      v-if="show_decoration"
      class="faq-block__decoration">
      <faq-ribbon-icon/>
    </div>

    <div class="container">
      <div class="faq-block__card">
        <default-title
          v-if="title"
          class="faq-block__title"
          :title="title"
          :title_tag="title_tag"/>
        <accordion
          class="faq-block__list"
          content_as_html
          :items="items"/>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "../modules/Accordion/Accordion.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import FaqRibbonIcon from "../icons/FaqRibbonIcon.vue";

export default {
  name: "FaqBlock",
  components: {FaqRibbonIcon, DefaultTitle, Accordion},
  // Nota despre propuri (nu poate sta intre marcajele de mai jos — parserul citeste
  // tot ce e intre ele ca JSON si o linie de comentariu il face sa cedeze tacit,
  // lasand componenta fara campuri editabile in page builder):
  //
  // `overlap_previous` urca blocul peste cel de deasupra. E prop, nu clasa
  // `mt-minus-*` din builder, pentru ca acelea merg din 20 in 20, iar macheta cere
  // exact 145px.
  props: {
    /**props**/
    title: {
      type: String,
      default: 'FAQs',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    show_decoration: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    overlap_previous: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    items: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
      }
    },
    /**props**/
  }
}
</script>
